// JQUERY EASING
!function (n) { "function" == typeof define && define.amd ? define(["jquery"], function (e) { return n(e) }) : "object" == typeof module && "object" == typeof module.exports ? module.exports = n(require("jquery")) : n(jQuery) }(function (n) { function e(n) { var e = 7.5625, t = 2.75; return n < 1 / t ? e * n * n : n < 2 / t ? e * (n -= 1.5 / t) * n + .75 : n < 2.5 / t ? e * (n -= 2.25 / t) * n + .9375 : e * (n -= 2.625 / t) * n + .984375 } void 0 !== n.easing && (n.easing.jswing = n.easing.swing); var t = Math.pow, u = Math.sqrt, r = Math.sin, i = Math.cos, a = Math.PI, o = 1.70158, c = 1.525 * o, s = 2 * a / 3, f = 2 * a / 4.5; return n.extend(n.easing, { def: "easeOutQuad", swing: function (e) { return n.easing[n.easing.def](e) }, easeInQuad: function (n) { return n * n }, easeOutQuad: function (n) { return 1 - (1 - n) * (1 - n) }, easeInOutQuad: function (n) { return n < .5 ? 2 * n * n : 1 - t(-2 * n + 2, 2) / 2 }, easeInCubic: function (n) { return n * n * n }, easeOutCubic: function (n) { return 1 - t(1 - n, 3) }, easeInOutCubic: function (n) { return n < .5 ? 4 * n * n * n : 1 - t(-2 * n + 2, 3) / 2 }, easeInQuart: function (n) { return n * n * n * n }, easeOutQuart: function (n) { return 1 - t(1 - n, 4) }, easeInOutQuart: function (n) { return n < .5 ? 8 * n * n * n * n : 1 - t(-2 * n + 2, 4) / 2 }, easeInQuint: function (n) { return n * n * n * n * n }, easeOutQuint: function (n) { return 1 - t(1 - n, 5) }, easeInOutQuint: function (n) { return n < .5 ? 16 * n * n * n * n * n : 1 - t(-2 * n + 2, 5) / 2 }, easeInSine: function (n) { return 1 - i(n * a / 2) }, easeOutSine: function (n) { return r(n * a / 2) }, easeInOutSine: function (n) { return -(i(a * n) - 1) / 2 }, easeInExpo: function (n) { return 0 === n ? 0 : t(2, 10 * n - 10) }, easeOutExpo: function (n) { return 1 === n ? 1 : 1 - t(2, -10 * n) }, easeInOutExpo: function (n) { return 0 === n ? 0 : 1 === n ? 1 : n < .5 ? t(2, 20 * n - 10) / 2 : (2 - t(2, -20 * n + 10)) / 2 }, easeInCirc: function (n) { return 1 - u(1 - t(n, 2)) }, easeOutCirc: function (n) { return u(1 - t(n - 1, 2)) }, easeInOutCirc: function (n) { return n < .5 ? (1 - u(1 - t(2 * n, 2))) / 2 : (u(1 - t(-2 * n + 2, 2)) + 1) / 2 }, easeInElastic: function (n) { return 0 === n ? 0 : 1 === n ? 1 : -t(2, 10 * n - 10) * r((10 * n - 10.75) * s) }, easeOutElastic: function (n) { return 0 === n ? 0 : 1 === n ? 1 : t(2, -10 * n) * r((10 * n - .75) * s) + 1 }, easeInOutElastic: function (n) { return 0 === n ? 0 : 1 === n ? 1 : n < .5 ? -t(2, 20 * n - 10) * r((20 * n - 11.125) * f) / 2 : t(2, -20 * n + 10) * r((20 * n - 11.125) * f) / 2 + 1 }, easeInBack: function (n) { return 2.70158 * n * n * n - o * n * n }, easeOutBack: function (n) { return 1 + 2.70158 * t(n - 1, 3) + o * t(n - 1, 2) }, easeInOutBack: function (n) { return n < .5 ? t(2 * n, 2) * (7.189819 * n - c) / 2 : (t(2 * n - 2, 2) * ((c + 1) * (2 * n - 2) + c) + 2) / 2 }, easeInBounce: function (n) { return 1 - e(1 - n) }, easeOutBounce: e, easeInOutBounce: function (n) { return n < .5 ? (1 - e(1 - 2 * n)) / 2 : (1 + e(2 * n - 1)) / 2 } }), n });
// ================================
// ================================
// ================================
// default easing
jQuery.easing.def = "easeInOutCubic";
// ================================
// ================================
// ================================



// forEach polyfill just in case
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
// ================================

// input status
function checkFill(item) {
  if (item.value.length) {
    item.classList.add('m-filled');
  }
  else {
    item.classList.remove('m-filled');
  }
}
var inputs = document.querySelectorAll('.nn-form__input');
inputs.forEach(function (item) {
  checkFill(item)
  item.onfocus = function () {
    item.classList.add('m-focused');
  }
  item.onblur = function () {
    item.classList.remove('m-focused');
    checkFill(item)
  }
  item.onkeyup = function () {
    checkFill(item)
  }
});
// ========================


$(function () {

  const scrollDuration = 1000;

  // SCROLL TO
  function scrollTo(target, correction, speed) {
    $('html, body')
      .stop()
      .animate(
        {
          scrollTop: $(target).offset().top - correction,
        },
        speed
      );
  }

  $(document).on('click', '.js_scrollto', function (e) {
    $(this).trigger('blur');
    let thisTarget = '';
    if ($(this).attr('href')) {
      thisTarget = $(this).attr('href');
    }
    else if ($(this).attr('data-scroll-target')) {
      thisTarget = $(this).attr('data-scroll-target');
    }
    scrollTo(thisTarget, 77, scrollDuration);

    e.preventDefault();
  });

  // SCROLL TO TOP
  $(document).on('click', '.js_tothetop', function (e) {
    scrollTo($('body'), 0, scrollDuration);

    e.preventDefault();
  });
  // ========================



  // input clear
  $(document).on('click', '.js_input_clear', function (e) {
    const targetInput = $(this).siblings('input');
    targetInput.val('').removeClass('m-filled').trigger('focus');

    e.preventDefault();
  });
  // ========================



  // FULL POPUP STUFF
  function bodyStopScroll() {
    //Get real width of page scroll-bar
    let w1 = $(window).width();

    $('html').addClass('popup_lock');

    let w2 = $(window).width();

    $("<style id='scrollStuff' type='text/css'>.popup_show_margin{padding-right:" + (w2 - w1) + 'px;}body.popup_show_margin{width:auto;}</style>').appendTo('head');

    $('body, .js_popup_show_margin').addClass('popup_show_margin');
  }

  function bodyRemoveStopScroll() {
    $('body, .js_popup_show_margin').removeClass('popup_show_margin');
    $('html').removeClass('popup_lock');
    $('#scrollStuff').remove();
    $('.b-pop-up__wrap').removeClass('over');
  }

  // show popup
  $(document).on('click', '.js_show_photo', function (e) {
    const filePath = $(this).attr('data-filepath');

    const thePhoto = `<picture class="nn-popup__photo">
      <source type="image/webp" srcset="${filePath}.webp 1x, ${filePath}@2x.webp 2x">
      <img class="nn-popup__photo-img" src="${filePath}.jpg" srcset="${filePath}@2x.jpg 2x" alt="">
    </picture>`

    $('.js_popup_content').html('').html(thePhoto);

    // bodyStopScroll();

    $('.js_popup').addClass('m-active').css('display', 'flex').hide().stop().fadeIn(300);

    e.preventDefault();
  });
  // hide popup
  $(document).on('click', '.js_popup_close', function (e) {
    $('.js_popup.m-active').removeClass('m-active').stop().fadeOut(300);
    // setTimeout(bodyRemoveStopScroll, 300);
    e.preventDefault();
  });

  $(document).on('keyup', function (e) {
    if (e.key == 'Escape') $('.js_popup.m-active .js_popup_close').trigger('click');
  });
  // ========================




  // show stuff
  let showArr = [];

  $('.js_show_trigger').each(function () {
    const showClass = $(this).attr('data-show');
    showArr.push(showClass);
  });

  function showStuff(showClass) {
    showArr.forEach(function (e, i) {
      $('body').removeClass(showArr[i]);
    });
    $('body').addClass(showClass)
  }

  $(document).on('click', '.js_show_trigger', function (e) {
    const showClass = $(this).attr('data-show');
    $('.js_show_trigger').removeClass('m-active');
    $(this).addClass('m-active');
    showStuff(showClass);
    e.preventDefault();
  });

  // show default
  $('.js_show_trigger.js-default').each(function () {
    const showClass = $(this).attr('data-show');
    $('.js_show_trigger').removeClass('m-active');
    $(this).addClass('m-active');
    showStuff(showClass);
  });


  // ========================


});

// =================================================
// =================================================
// =================================================
